import React from 'react';
import { USE_FIREBASE_EMULATORS, EMULATOR_PORTS } from '../firebase';

export default function EmulatorBanner() {
  if (!USE_FIREBASE_EMULATORS) return null;

  return (
    <div className="emulator-banner" role="status">
      Local Firebase emulators — not production
      <a
        href={`http://127.0.0.1:${EMULATOR_PORTS.ui}`}
        target="_blank"
        rel="noreferrer"
      >
        Emulator UI
      </a>
    </div>
  );
}
